import cssVariables from 'tfs.css-variables'

export default {
  operatorSelect: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',

    '& > h4': {
      color: cssVariables.colorBlack,
      marginRight: '1rem',
    },
  },
  inputField: {
    width: '20em',
    height: '3em',
    border: `0.1em solid ${cssVariables.colorWhiteBorder}`,
    borderRadius: '0.5rem',
    '&:focus': {
      borderColor: cssVariables.colorBlue,
      outline: 'none',
    },
  },
}
